import axiosInstance from '../axiosConfig';

export type EmailQueueStatus = 'PENDING' | 'SENT' | 'FAILED';
export type EmailQueueErrorType = 'TOKEN_ACQUISITION' | 'SMTP' | 'UNKNOWN';

export interface EmailQueueItem {
    id: string;
    to: string;
    subject: string;
    html: string;
    status: EmailQueueStatus;
    attempts: number;
    lastError?: string;
    lastErrorType?: EmailQueueErrorType;
    createdAt?: string;
    lastAttemptAt?: string;
    sentAt?: string;
}

export const EmailQueueService = {
    async fetchQueue(): Promise<EmailQueueItem[]> {
        const response = await axiosInstance.get<EmailQueueItem[]>('/api/email-queue');
        return response.data;
    },

    async retry(id: string): Promise<EmailQueueItem> {
        const response = await axiosInstance.post<EmailQueueItem>(`/api/email-queue/${id}/retry`);
        return response.data;
    },

    async retryAllPending(): Promise<EmailQueueItem[]> {
        const response = await axiosInstance.post<EmailQueueItem[]>('/api/email-queue/retry-pending');
        return response.data;
    },

    async pendingCount(): Promise<number> {
        const response = await axiosInstance.get<{ count: number }>('/api/email-queue/pending-count');
        return response.data.count;
    }
};
